const storageKey = 'nifty_';

const hasLocalStorage = () => {
    let supports = false;
    try {
        supports = 'localStorage' in window && typeof localStorage === 'object' && localStorage && typeof localStorage.getItem === 'function' && typeof localStorage.setItem === 'function';
    } catch(e) {
        supports = false;
    }

    return supports;
}

export const set = (key, value) => {
    if (!hasLocalStorage()) {
        return null;
    }

    localStorage.setItem(storageKey + key, JSON.stringify(value));
}

export const get = key => {
    if (!hasLocalStorage()) {
        return null;
    }

    const result = localStorage.getItem(storageKey + key);

    try {
        return JSON.parse(result);
    } catch(e) {
        return result;
    }
}

export const remove = key => {
    if (!hasLocalStorage()) {
        return null;
    }

    localStorage.removeItem(storageKey + key);
}
